import { deepCopy } from '@/helpers/misc';
import { CheckAuthService } from '@/services/checkAuthService';
import type { LoginResponse, User } from '@/types/auth'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

const USER_INFO_KEY = 'user_info';
const TENANT_KEY = 'current_tenant';

function getEmptyUser(): User {
    return {
        tenants: [],
        firstname: '',
        lastname: '',
        login: '',
        adminflag: false,
        lockedFlag: false,
    }
}

export const useUserStore = defineStore('user', () => {
    const checkAuthService = new CheckAuthService();

    const router = useRouter();

    const user = ref<User | null>(null);
    const tenant = ref<string | null>(null);

    const fullName = computed((): string => {
        return user.value
            ? `${user.value.firstname} ${user.value.lastname}`.trim()
            : '';
    });

    const isUserInfoSet = computed((): boolean => {
        return !!(user.value?.firstname && user.value?.lastname && user.value?.login);
    });

    const isTenantAdmin = computed((): boolean => {
        if (!user.value || !tenant.value) return false;
        const fTenant = user.value.tenants.find((t) => t.tenant === tenant.value);
        return !!(fTenant && fTenant.adminflag);
    });

    function setUserInfo(loginResponse: LoginResponse) {
        const copy = deepCopy<LoginResponse>(loginResponse) as Partial<LoginResponse>;
        delete copy.success;
        user.value = copy as User;
        localStorage.setItem(USER_INFO_KEY, JSON.stringify(copy));
    }

    function clearUserInfo() {
        localStorage.removeItem(USER_INFO_KEY);
    }

    async function init() {
        const userInfo = await checkAuthService.isAuthenticated();
        if (userInfo) {
            setUserInfo(userInfo);
        }
        tenant.value = localStorage.getItem(TENANT_KEY) || null;
        console.log('init tenant', tenant.value);
    }

    function setTenant(newTenant: string | null) {
        tenant.value = newTenant;
        console.log('set tenant to', newTenant);
        if (tenant.value) {
            localStorage.setItem(TENANT_KEY, tenant.value);
            console.log('push user to dashboard');
            const currentLang = router.currentRoute.value.params.lang || 'de';
            // Hard-Reload zwingt den Browser auf die neue URL und löscht den RAM/State komplett
            window.location.href = `/${currentLang}/user/dashboard`;
            // router.push({ name: 'dashboard', params: { lang: 'en' }, hash: '' })
            //     .then(() => console.log('Navigation erfolgreich'))
            //     .catch(err => console.error('Router Fehler:', err));
        } else {
            localStorage.removeItem(TENANT_KEY);
        }
    }

    return {
        // State
        user,
        tenant,
        // Getters
        fullName,
        isUserInfoSet,
        isTenantAdmin,
        // Actions
        setUserInfo,
        clearUserInfo,
        init,
        setTenant,
    };
});